import React from "react";
import { useUsageLimitContext } from "@/context/UsageLimitContext";
import { getUsageLimitMessage } from "@/hooks/useUsageLimits";
import { UsageWarningBanner } from "./UsageWarningBanner";

export const UsageLimitErrorBanner: React.FC = () => {
  const { currentError, clearLimitError, setShowPricingDialog } = useUsageLimitContext();

  if (!currentError) return null;

  const { title, description } = getUsageLimitMessage(currentError.usageType);

  const handleUpgrade = () => {
    clearLimitError();
    setShowPricingDialog(true);
  };

  return (
    <UsageWarningBanner
      variant="error"
      message={`${title} ${description}`}
      mobileMessage={title}
      actionLabel="Upgrade now"
      mobileActionLabel="Upgrade"
      onAction={handleUpgrade}
      dismissible={true}
    />
  );
};
